export class TopicTransformer {
  static transform(obj) {
    return obj;
  }
}



// WEBPACK FOOTER //
// ./src/helpers/topics/topic.transformer.js